class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("cart-notification");
    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close(),
    );
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this)),
    );
  }

  open() {
    this.notification.classList.add("animate", "active");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true },
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    this.notification.classList.remove("active");
    document.body.removeEventListener("click", this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKeys = this.getAddedItemKeys(parsedState);
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.getElementById(section.id);
      if (!sectionElement) return;

      if (section.id === "cart-notification-product") {
        sectionElement.innerHTML = this.getProductSectionInnerHTML(
          parsedState.sections[section.id],
        );
        return;
      }

      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getAddedItemKeys(parsedState) {
    if (Array.isArray(parsedState.items) && parsedState.items.length) {
      return parsedState.items.map((item) => item.key).filter(Boolean);
    }

    return parsedState.key ? [parsedState.key] : [];
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
      },
      {
        id: "cart-notification-button",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    if (!html) return "";

    const target = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
    return target ? target.innerHTML : "";
  }

  getProductSectionInnerHTML(html) {
    if (!html || !this.cartItemKeys?.length) return "";

    const documentFragment = new DOMParser().parseFromString(html, "text/html");

    return this.cartItemKeys
      .map((key) =>
        documentFragment.querySelector(
          `[id="cart-notification-product-${key}"]`,
        ),
      )
      .filter(Boolean)
      .map((item) => item.outerHTML)
      .join("");
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest("cart-notification")) {
      const disclosure = target.closest("details-disclosure, header-menu");
      this.activeElement = disclosure
        ? disclosure.querySelector("summary")
        : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);
